<div class="input-group">
  <input
    class="form-control"
    [class.open]="open"
    [(ngModel)]="text"
    [ngModelOptions]="{ standalone: true }"
    (keyup)="searchTerm(text)"
    type="text"
    autocomplete="off"
    placeholder="Search.."
  /><span class="input-group-text mobile-search" (click)="openMenu()">
    <i data-feather="search"></i
  ></span>
</div>
<div
  class="Typeahead-menu"
  [class.is-open]="searchResult"
  *ngIf="menuItems?.length || (isOnMailRoute() && (messageResults?.length || isSearchingMessages || (text && text.length >= 2)))"
  id="search-outer"
  [class.open]="open"
>
  <!-- Message Results Section (only on mail routes) -->
  <ng-container *ngIf="isOnMailRoute()">
    <div class="search-section-header" *ngIf="messageResults.length > 0 || isSearchingMessages || (text && text.length >= 2)">
      Съобщения
    </div>
    <div class="search-loading" *ngIf="isSearchingMessages">
      <i class="fa fa-spinner fa-spin"></i> Търсене...
    </div>
    <ng-container *ngIf="!isSearchingMessages">
      <div *ngFor="let msg of messageResults | slice:0:5" class="message-result" (dblclick)="onMessageClick(msg)">
        <div class="message-result-icon">
          <app-feather-icon [icon]="'mail'"></app-feather-icon>
        </div>
        <div class="message-result-content">
          <div class="msg-subject">{{ msg.subject | slice:0:50 }}{{ msg.subject?.length > 50 ? '...' : '' }}</div>
          <div class="msg-meta">{{ msg.senderProfileName }} • {{ msg.dateSent | date:'dd.MM.yyyy' }}</div>
        </div>
      </div>
    </ng-container>
    <div class="search-empty" *ngIf="!isSearchingMessages && messageResults.length === 0 && text && text.length >= 2">
      Няма намерени съобщения
    </div>
  </ng-container>

  <!-- Navigation Section Header (only if on mail route and has menu results) -->
  <div class="search-section-header" *ngIf="isOnMailRoute() && menuItems?.length">
    Навигация
  </div>

  <div
    class="ProfileCard u-cf"
    *ngFor="let menuItem of menuItems | slice : 0 : 8"
  >
    <div class="ProfileCard-avatar">
      <app-feather-icon [icon]="menuItem.icon"></app-feather-icon>
    </div>
    <div class="ProfileCard-details">
      <div class="ProfileCard-realName">
        <a
          [routerLink]="menuItem?.path"
          class="realname"
          (click)="removeFix()"
          >{{ menuItem?.title }}</a
        >
      </div>
    </div>
  </div>
</div>
